/*
* ------------------------------------------------------------------------------
* QUANTITY INPUT - Custom quantity input field with plus and minus buttons
* ------------------------------------------------------------------------------
* Copyright 2021 Elkfox Co Pty Ltd - All rights reserved
* ------------------------------------------------------------------------------
*/

if (customElements.get('quantity-input') === undefined) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();

      this.input = this.querySelector('input');
      this.changeEvent = new Event('change', { bubbles: true })

      this.querySelectorAll('button').forEach((button) =>
        button.addEventListener('click', this.onButtonClick.bind(this))
      );
    }

    onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;

      if (event.target.name === 'minus' && this.input.min === this.input.value) return;
      event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
  }

  customElements.define('quantity-input', QuantityInput);
}
